/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DevSimRouteImport } from './routes/dev-sim'
import { Route as DashboardMockRouteImport } from './routes/dashboard-mock'
import { Route as WsRouteImport } from './routes/_ws'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as JoinTokenRouteImport } from './routes/join/$token'
import { Route as WsWorkspacesRouteImport } from './routes/_ws/workspaces'
import { Route as WsNoAccessRouteImport } from './routes/_ws/no-access'
import { Route as WsInviteMembersRouteImport } from './routes/_ws/invite-members'
import { Route as WsCreateWorkspaceRouteImport } from './routes/_ws/create-workspace'
import { Route as AppProjectsRouteImport } from './routes/_app/projects'
import { Route as AppForbiddenRouteImport } from './routes/_app/forbidden'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppBuyingPlanRouteImport } from './routes/_app/buying-plan'
import { Route as AppBrandsRouteImport } from './routes/_app/brands'
import { Route as AppAgentsRouteImport } from './routes/_app/agents'
import { Route as AppProjectIdRouteImport } from './routes/_app/$projectId'
import { Route as WsWorkspacesIndexRouteImport } from './routes/_ws/workspaces/index'
import { Route as AppProjectIdIndexRouteImport } from './routes/_app/$projectId/index'
import { Route as PublicArtifactsArtifactIdRouteImport } from './routes/public.artifacts.$artifactId'
import { Route as FeedbackFeedbackIdImageRouteImport } from './routes/feedback.$feedbackId.image'
import { Route as WsWorkspacesOpenRouteImport } from './routes/_ws/workspaces/open'
import { Route as WsWWorkspaceIdRouteImport } from './routes/_ws/w/$workspaceId'
import { Route as AppProjectIdMemoryRouteImport } from './routes/_app/$projectId/memory'
import { Route as AppProjectIdAgentIdRouteImport } from './routes/_app/$projectId/$agentId'
import { Route as AppProjectIdSplatRouteImport } from './routes/_app/$projectId/$'
import { Route as WsWWorkspaceIdIndexRouteImport } from './routes/_ws/w/$workspaceId/index'
import { Route as AppProjectIdAgentIdIndexRouteImport } from './routes/_app/$projectId/$agentId/index'
import { Route as WsWWorkspaceIdSettingsRouteImport } from './routes/_ws/w/$workspaceId/settings'
import { Route as WsWWorkspaceIdSeatsBillingRouteImport } from './routes/_ws/w/$workspaceId/seats-billing'
import { Route as WsWWorkspaceIdRequestsRouteImport } from './routes/_ws/w/$workspaceId/requests'
import { Route as WsWWorkspaceIdProjectsRouteImport } from './routes/_ws/w/$workspaceId/projects'
import { Route as WsWWorkspaceIdOverviewRouteImport } from './routes/_ws/w/$workspaceId/overview'
import { Route as WsWWorkspaceIdNotificationsRouteImport } from './routes/_ws/w/$workspaceId/notifications'
import { Route as WsWWorkspaceIdMembersRouteImport } from './routes/_ws/w/$workspaceId/members'
import { Route as WsWWorkspaceIdCreditsRouteImport } from './routes/_ws/w/$workspaceId/credits'
import { Route as WsWWorkspaceIdConnectedAppsRouteImport } from './routes/_ws/w/$workspaceId/connected-apps'
import { Route as WsWWorkspaceIdBrandsRouteImport } from './routes/_ws/w/$workspaceId/brands'
import { Route as WsWWorkspaceIdBillingRouteImport } from './routes/_ws/w/$workspaceId/billing'
import { Route as AppProjectIdObjectsObjectIdRouteImport } from './routes/_app/$projectId/objects/$objectId'
import { Route as AppProjectIdAgentIdSplatRouteImport } from './routes/_app/$projectId/$agentId/$'
import { Route as WsWWorkspaceIdSeatsBillingIndexRouteImport } from './routes/_ws/w/$workspaceId/seats-billing/index'
import { Route as WsWWorkspaceIdProjectsIndexRouteImport } from './routes/_ws/w/$workspaceId/projects/index'
import { Route as WsWWorkspaceIdCreditsIndexRouteImport } from './routes/_ws/w/$workspaceId/credits/index'
import { Route as WsWWorkspaceIdBrandsIndexRouteImport } from './routes/_ws/w/$workspaceId/brands/index'
import { Route as WsWWorkspaceIdBillingIndexRouteImport } from './routes/_ws/w/$workspaceId/billing/index'
import { Route as WsWWorkspaceIdSeatsBillingSeatsRouteImport } from './routes/_ws/w/$workspaceId/seats-billing/seats'
import { Route as WsWWorkspaceIdSeatsBillingPlanRouteImport } from './routes/_ws/w/$workspaceId/seats-billing/plan'
import { Route as WsWWorkspaceIdSeatsBillingPaymentRouteImport } from './routes/_ws/w/$workspaceId/seats-billing/payment'
import { Route as WsWWorkspaceIdSeatsBillingBillingRouteImport } from './routes/_ws/w/$workspaceId/seats-billing/billing'
import { Route as WsWWorkspaceIdProjectsProjectIdRouteImport } from './routes/_ws/w/$workspaceId/projects/$projectId'
import { Route as WsWWorkspaceIdMembersSeatsRouteImport } from './routes/_ws/w/$workspaceId/members/seats'
import { Route as WsWWorkspaceIdCreditsUsageRouteImport } from './routes/_ws/w/$workspaceId/credits/usage'
import { Route as WsWWorkspaceIdCreditsOverviewRouteImport } from './routes/_ws/w/$workspaceId/credits/overview'
import { Route as WsWWorkspaceIdCreditsCapsRouteImport } from './routes/_ws/w/$workspaceId/credits/caps'
import { Route as WsWWorkspaceIdCreditsAllocationRouteImport } from './routes/_ws/w/$workspaceId/credits/allocation'
import { Route as WsWWorkspaceIdBrandsBrandIdRouteImport } from './routes/_ws/w/$workspaceId/brands/$brandId'
import { Route as WsWWorkspaceIdBillingPlanRouteImport } from './routes/_ws/w/$workspaceId/billing/plan'
import { Route as WsWWorkspaceIdBillingPaymentRouteImport } from './routes/_ws/w/$workspaceId/billing/payment'
import { Route as AppProjectIdAgentIdDocumentsDocumentIdRouteImport } from './routes/_app/$projectId/$agentId/documents/$documentId'
import { Route as WsWWorkspaceIdProjectsProjectIdIndexRouteImport } from './routes/_ws/w/$workspaceId/projects/$projectId/index'
import { Route as WsWWorkspaceIdBrandsBrandIdIndexRouteImport } from './routes/_ws/w/$workspaceId/brands/$brandId/index'
import { Route as WsWWorkspaceIdProjectsProjectIdAccessRouteImport } from './routes/_ws/w/$workspaceId/projects/$projectId/access'
import { Route as WsWWorkspaceIdBrandsBrandIdSettingsRouteImport } from './routes/_ws/w/$workspaceId/brands/$brandId/settings'
import { Route as WsWWorkspaceIdBrandsBrandIdPlaybookRouteImport } from './routes/_ws/w/$workspaceId/brands/$brandId/playbook'
import { Route as WsWWorkspaceIdBrandsBrandIdAccessRouteImport } from './routes/_ws/w/$workspaceId/brands/$brandId/access'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DevSimRoute = DevSimRouteImport.update({
  id: '/dev-sim',
  path: '/dev-sim',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardMockRoute = DashboardMockRouteImport.update({
  id: '/dashboard-mock',
  path: '/dashboard-mock',
  getParentRoute: () => rootRouteImport,
} as any)
const WsRoute = WsRouteImport.update({
  id: '/_ws',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const WsWorkspacesRoute = WsWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => WsRoute,
} as any)
const WsNoAccessRoute = WsNoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => WsRoute,
} as any)
const WsInviteMembersRoute = WsInviteMembersRouteImport.update({
  id: '/invite-members',
  path: '/invite-members',
  getParentRoute: () => WsRoute,
} as any)
const WsCreateWorkspaceRoute = WsCreateWorkspaceRouteImport.update({
  id: '/create-workspace',
  path: '/create-workspace',
  getParentRoute: () => WsRoute,
} as any)
const AppProjectsRoute = AppProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppForbiddenRoute = AppForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppBuyingPlanRoute = AppBuyingPlanRouteImport.update({
  id: '/buying-plan',
  path: '/buying-plan',
  getParentRoute: () => AppRoute,
} as any)
const AppBrandsRoute = AppBrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsRoute = AppAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectIdRoute = AppProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => AppRoute,
} as any)
const WsWorkspacesIndexRoute = WsWorkspacesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WsWorkspacesRoute,
} as any)
const AppProjectIdIndexRoute = AppProjectIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProjectIdRoute,
} as any)
const PublicArtifactsArtifactIdRoute =
  PublicArtifactsArtifactIdRouteImport.update({
    id: '/public/artifacts/$artifactId',
    path: '/public/artifacts/$artifactId',
    getParentRoute: () => rootRouteImport,
  } as any)
const FeedbackFeedbackIdImageRoute = FeedbackFeedbackIdImageRouteImport.update({
  id: '/feedback/$feedbackId/image',
  path: '/feedback/$feedbackId/image',
  getParentRoute: () => rootRouteImport,
} as any)
const WsWorkspacesOpenRoute = WsWorkspacesOpenRouteImport.update({
  id: '/open',
  path: '/open',
  getParentRoute: () => WsWorkspacesRoute,
} as any)
const WsWWorkspaceIdRoute = WsWWorkspaceIdRouteImport.update({
  id: '/w/$workspaceId',
  path: '/w/$workspaceId',
  getParentRoute: () => WsRoute,
} as any)
const AppProjectIdMemoryRoute = AppProjectIdMemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => AppProjectIdRoute,
} as any)
const AppProjectIdAgentIdRoute = AppProjectIdAgentIdRouteImport.update({
  id: '/$agentId',
  path: '/$agentId',
  getParentRoute: () => AppProjectIdRoute,
} as any)
const AppProjectIdSplatRoute = AppProjectIdSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppProjectIdRoute,
} as any)
const WsWWorkspaceIdIndexRoute = WsWWorkspaceIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WsWWorkspaceIdRoute,
} as any)
const AppProjectIdAgentIdIndexRoute =
  AppProjectIdAgentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectIdAgentIdRoute,
  } as any)
const WsWWorkspaceIdSettingsRoute = WsWWorkspaceIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => WsWWorkspaceIdRoute,
} as any)
const WsWWorkspaceIdSeatsBillingRoute =
  WsWWorkspaceIdSeatsBillingRouteImport.update({
    id: '/seats-billing',
    path: '/seats-billing',
    getParentRoute: () => WsWWorkspaceIdRoute,
  } as any)
const WsWWorkspaceIdRequestsRoute = WsWWorkspaceIdRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => WsWWorkspaceIdRoute,
} as any)
const WsWWorkspaceIdProjectsRoute = WsWWorkspaceIdProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => WsWWorkspaceIdRoute,
} as any)
const WsWWorkspaceIdOverviewRoute = WsWWorkspaceIdOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => WsWWorkspaceIdRoute,
} as any)
const WsWWorkspaceIdNotificationsRoute =
  WsWWorkspaceIdNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => WsWWorkspaceIdRoute,
  } as any)
const WsWWorkspaceIdMembersRoute = WsWWorkspaceIdMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => WsWWorkspaceIdRoute,
} as any)
const WsWWorkspaceIdCreditsRoute = WsWWorkspaceIdCreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => WsWWorkspaceIdRoute,
} as any)
const WsWWorkspaceIdConnectedAppsRoute =
  WsWWorkspaceIdConnectedAppsRouteImport.update({
    id: '/connected-apps',
    path: '/connected-apps',
    getParentRoute: () => WsWWorkspaceIdRoute,
  } as any)
const WsWWorkspaceIdBrandsRoute = WsWWorkspaceIdBrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => WsWWorkspaceIdRoute,
} as any)
const WsWWorkspaceIdBillingRoute = WsWWorkspaceIdBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => WsWWorkspaceIdRoute,
} as any)
const AppProjectIdObjectsObjectIdRoute =
  AppProjectIdObjectsObjectIdRouteImport.update({
    id: '/objects/$objectId',
    path: '/objects/$objectId',
    getParentRoute: () => AppProjectIdRoute,
  } as any)
const AppProjectIdAgentIdSplatRoute =
  AppProjectIdAgentIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AppProjectIdAgentIdRoute,
  } as any)
const WsWWorkspaceIdSeatsBillingIndexRoute =
  WsWWorkspaceIdSeatsBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WsWWorkspaceIdSeatsBillingRoute,
  } as any)
const WsWWorkspaceIdProjectsIndexRoute =
  WsWWorkspaceIdProjectsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WsWWorkspaceIdProjectsRoute,
  } as any)
const WsWWorkspaceIdCreditsIndexRoute =
  WsWWorkspaceIdCreditsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WsWWorkspaceIdCreditsRoute,
  } as any)
const WsWWorkspaceIdBrandsIndexRoute =
  WsWWorkspaceIdBrandsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WsWWorkspaceIdBrandsRoute,
  } as any)
const WsWWorkspaceIdBillingIndexRoute =
  WsWWorkspaceIdBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WsWWorkspaceIdBillingRoute,
  } as any)
const WsWWorkspaceIdSeatsBillingSeatsRoute =
  WsWWorkspaceIdSeatsBillingSeatsRouteImport.update({
    id: '/seats',
    path: '/seats',
    getParentRoute: () => WsWWorkspaceIdSeatsBillingRoute,
  } as any)
const WsWWorkspaceIdSeatsBillingPlanRoute =
  WsWWorkspaceIdSeatsBillingPlanRouteImport.update({
    id: '/plan',
    path: '/plan',
    getParentRoute: () => WsWWorkspaceIdSeatsBillingRoute,
  } as any)
const WsWWorkspaceIdSeatsBillingPaymentRoute =
  WsWWorkspaceIdSeatsBillingPaymentRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => WsWWorkspaceIdSeatsBillingRoute,
  } as any)
const WsWWorkspaceIdSeatsBillingBillingRoute =
  WsWWorkspaceIdSeatsBillingBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => WsWWorkspaceIdSeatsBillingRoute,
  } as any)
const WsWWorkspaceIdProjectsProjectIdRoute =
  WsWWorkspaceIdProjectsProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => WsWWorkspaceIdProjectsRoute,
  } as any)
const WsWWorkspaceIdMembersSeatsRoute =
  WsWWorkspaceIdMembersSeatsRouteImport.update({
    id: '/seats',
    path: '/seats',
    getParentRoute: () => WsWWorkspaceIdMembersRoute,
  } as any)
const WsWWorkspaceIdCreditsUsageRoute =
  WsWWorkspaceIdCreditsUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => WsWWorkspaceIdCreditsRoute,
  } as any)
const WsWWorkspaceIdCreditsOverviewRoute =
  WsWWorkspaceIdCreditsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => WsWWorkspaceIdCreditsRoute,
  } as any)
const WsWWorkspaceIdCreditsCapsRoute =
  WsWWorkspaceIdCreditsCapsRouteImport.update({
    id: '/caps',
    path: '/caps',
    getParentRoute: () => WsWWorkspaceIdCreditsRoute,
  } as any)
const WsWWorkspaceIdCreditsAllocationRoute =
  WsWWorkspaceIdCreditsAllocationRouteImport.update({
    id: '/allocation',
    path: '/allocation',
    getParentRoute: () => WsWWorkspaceIdCreditsRoute,
  } as any)
const WsWWorkspaceIdBrandsBrandIdRoute =
  WsWWorkspaceIdBrandsBrandIdRouteImport.update({
    id: '/$brandId',
    path: '/$brandId',
    getParentRoute: () => WsWWorkspaceIdBrandsRoute,
  } as any)
const WsWWorkspaceIdBillingPlanRoute =
  WsWWorkspaceIdBillingPlanRouteImport.update({
    id: '/plan',
    path: '/plan',
    getParentRoute: () => WsWWorkspaceIdBillingRoute,
  } as any)
const WsWWorkspaceIdBillingPaymentRoute =
  WsWWorkspaceIdBillingPaymentRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => WsWWorkspaceIdBillingRoute,
  } as any)
const AppProjectIdAgentIdDocumentsDocumentIdRoute =
  AppProjectIdAgentIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => AppProjectIdAgentIdRoute,
  } as any)
const WsWWorkspaceIdProjectsProjectIdIndexRoute =
  WsWWorkspaceIdProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WsWWorkspaceIdProjectsProjectIdRoute,
  } as any)
const WsWWorkspaceIdBrandsBrandIdIndexRoute =
  WsWWorkspaceIdBrandsBrandIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WsWWorkspaceIdBrandsBrandIdRoute,
  } as any)
const WsWWorkspaceIdProjectsProjectIdAccessRoute =
  WsWWorkspaceIdProjectsProjectIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => WsWWorkspaceIdProjectsProjectIdRoute,
  } as any)
const WsWWorkspaceIdBrandsBrandIdSettingsRoute =
  WsWWorkspaceIdBrandsBrandIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WsWWorkspaceIdBrandsBrandIdRoute,
  } as any)
const WsWWorkspaceIdBrandsBrandIdPlaybookRoute =
  WsWWorkspaceIdBrandsBrandIdPlaybookRouteImport.update({
    id: '/playbook',
    path: '/playbook',
    getParentRoute: () => WsWWorkspaceIdBrandsBrandIdRoute,
  } as any)
const WsWWorkspaceIdBrandsBrandIdAccessRoute =
  WsWWorkspaceIdBrandsBrandIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => WsWWorkspaceIdBrandsBrandIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/dashboard-mock': typeof DashboardMockRoute
  '/dev-sim': typeof DevSimRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/$projectId': typeof AppProjectIdRouteWithChildren
  '/agents': typeof AppAgentsRoute
  '/brands': typeof AppBrandsRoute
  '/buying-plan': typeof AppBuyingPlanRoute
  '/dashboard': typeof AppDashboardRoute
  '/forbidden': typeof AppForbiddenRoute
  '/projects': typeof AppProjectsRoute
  '/create-workspace': typeof WsCreateWorkspaceRoute
  '/invite-members': typeof WsInviteMembersRoute
  '/no-access': typeof WsNoAccessRoute
  '/workspaces': typeof WsWorkspacesRouteWithChildren
  '/join/$token': typeof JoinTokenRoute
  '/$projectId/$': typeof AppProjectIdSplatRoute
  '/$projectId/$agentId': typeof AppProjectIdAgentIdRouteWithChildren
  '/$projectId/memory': typeof AppProjectIdMemoryRoute
  '/w/$workspaceId': typeof WsWWorkspaceIdRouteWithChildren
  '/workspaces/open': typeof WsWorkspacesOpenRoute
  '/feedback/$feedbackId/image': typeof FeedbackFeedbackIdImageRoute
  '/public/artifacts/$artifactId': typeof PublicArtifactsArtifactIdRoute
  '/$projectId/': typeof AppProjectIdIndexRoute
  '/workspaces/': typeof WsWorkspacesIndexRoute
  '/$projectId/$agentId/$': typeof AppProjectIdAgentIdSplatRoute
  '/$projectId/objects/$objectId': typeof AppProjectIdObjectsObjectIdRoute
  '/w/$workspaceId/billing': typeof WsWWorkspaceIdBillingRouteWithChildren
  '/w/$workspaceId/brands': typeof WsWWorkspaceIdBrandsRouteWithChildren
  '/w/$workspaceId/connected-apps': typeof WsWWorkspaceIdConnectedAppsRoute
  '/w/$workspaceId/credits': typeof WsWWorkspaceIdCreditsRouteWithChildren
  '/w/$workspaceId/members': typeof WsWWorkspaceIdMembersRouteWithChildren
  '/w/$workspaceId/notifications': typeof WsWWorkspaceIdNotificationsRoute
  '/w/$workspaceId/overview': typeof WsWWorkspaceIdOverviewRoute
  '/w/$workspaceId/projects': typeof WsWWorkspaceIdProjectsRouteWithChildren
  '/w/$workspaceId/requests': typeof WsWWorkspaceIdRequestsRoute
  '/w/$workspaceId/seats-billing': typeof WsWWorkspaceIdSeatsBillingRouteWithChildren
  '/w/$workspaceId/settings': typeof WsWWorkspaceIdSettingsRoute
  '/$projectId/$agentId/': typeof AppProjectIdAgentIdIndexRoute
  '/w/$workspaceId/': typeof WsWWorkspaceIdIndexRoute
  '/$projectId/$agentId/documents/$documentId': typeof AppProjectIdAgentIdDocumentsDocumentIdRoute
  '/w/$workspaceId/billing/payment': typeof WsWWorkspaceIdBillingPaymentRoute
  '/w/$workspaceId/billing/plan': typeof WsWWorkspaceIdBillingPlanRoute
  '/w/$workspaceId/brands/$brandId': typeof WsWWorkspaceIdBrandsBrandIdRouteWithChildren
  '/w/$workspaceId/credits/allocation': typeof WsWWorkspaceIdCreditsAllocationRoute
  '/w/$workspaceId/credits/caps': typeof WsWWorkspaceIdCreditsCapsRoute
  '/w/$workspaceId/credits/overview': typeof WsWWorkspaceIdCreditsOverviewRoute
  '/w/$workspaceId/credits/usage': typeof WsWWorkspaceIdCreditsUsageRoute
  '/w/$workspaceId/members/seats': typeof WsWWorkspaceIdMembersSeatsRoute
  '/w/$workspaceId/projects/$projectId': typeof WsWWorkspaceIdProjectsProjectIdRouteWithChildren
  '/w/$workspaceId/seats-billing/billing': typeof WsWWorkspaceIdSeatsBillingBillingRoute
  '/w/$workspaceId/seats-billing/payment': typeof WsWWorkspaceIdSeatsBillingPaymentRoute
  '/w/$workspaceId/seats-billing/plan': typeof WsWWorkspaceIdSeatsBillingPlanRoute
  '/w/$workspaceId/seats-billing/seats': typeof WsWWorkspaceIdSeatsBillingSeatsRoute
  '/w/$workspaceId/billing/': typeof WsWWorkspaceIdBillingIndexRoute
  '/w/$workspaceId/brands/': typeof WsWWorkspaceIdBrandsIndexRoute
  '/w/$workspaceId/credits/': typeof WsWWorkspaceIdCreditsIndexRoute
  '/w/$workspaceId/projects/': typeof WsWWorkspaceIdProjectsIndexRoute
  '/w/$workspaceId/seats-billing/': typeof WsWWorkspaceIdSeatsBillingIndexRoute
  '/w/$workspaceId/brands/$brandId/access': typeof WsWWorkspaceIdBrandsBrandIdAccessRoute
  '/w/$workspaceId/brands/$brandId/playbook': typeof WsWWorkspaceIdBrandsBrandIdPlaybookRoute
  '/w/$workspaceId/brands/$brandId/settings': typeof WsWWorkspaceIdBrandsBrandIdSettingsRoute
  '/w/$workspaceId/projects/$projectId/access': typeof WsWWorkspaceIdProjectsProjectIdAccessRoute
  '/w/$workspaceId/brands/$brandId/': typeof WsWWorkspaceIdBrandsBrandIdIndexRoute
  '/w/$workspaceId/projects/$projectId/': typeof WsWWorkspaceIdProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/dashboard-mock': typeof DashboardMockRoute
  '/dev-sim': typeof DevSimRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/agents': typeof AppAgentsRoute
  '/brands': typeof AppBrandsRoute
  '/buying-plan': typeof AppBuyingPlanRoute
  '/dashboard': typeof AppDashboardRoute
  '/forbidden': typeof AppForbiddenRoute
  '/projects': typeof AppProjectsRoute
  '/create-workspace': typeof WsCreateWorkspaceRoute
  '/invite-members': typeof WsInviteMembersRoute
  '/no-access': typeof WsNoAccessRoute
  '/join/$token': typeof JoinTokenRoute
  '/$projectId/$': typeof AppProjectIdSplatRoute
  '/$projectId/memory': typeof AppProjectIdMemoryRoute
  '/workspaces/open': typeof WsWorkspacesOpenRoute
  '/feedback/$feedbackId/image': typeof FeedbackFeedbackIdImageRoute
  '/public/artifacts/$artifactId': typeof PublicArtifactsArtifactIdRoute
  '/$projectId': typeof AppProjectIdIndexRoute
  '/workspaces': typeof WsWorkspacesIndexRoute
  '/$projectId/$agentId/$': typeof AppProjectIdAgentIdSplatRoute
  '/$projectId/objects/$objectId': typeof AppProjectIdObjectsObjectIdRoute
  '/w/$workspaceId/connected-apps': typeof WsWWorkspaceIdConnectedAppsRoute
  '/w/$workspaceId/members': typeof WsWWorkspaceIdMembersRouteWithChildren
  '/w/$workspaceId/notifications': typeof WsWWorkspaceIdNotificationsRoute
  '/w/$workspaceId/overview': typeof WsWWorkspaceIdOverviewRoute
  '/w/$workspaceId/requests': typeof WsWWorkspaceIdRequestsRoute
  '/w/$workspaceId/settings': typeof WsWWorkspaceIdSettingsRoute
  '/$projectId/$agentId': typeof AppProjectIdAgentIdIndexRoute
  '/w/$workspaceId': typeof WsWWorkspaceIdIndexRoute
  '/$projectId/$agentId/documents/$documentId': typeof AppProjectIdAgentIdDocumentsDocumentIdRoute
  '/w/$workspaceId/billing/payment': typeof WsWWorkspaceIdBillingPaymentRoute
  '/w/$workspaceId/billing/plan': typeof WsWWorkspaceIdBillingPlanRoute
  '/w/$workspaceId/credits/allocation': typeof WsWWorkspaceIdCreditsAllocationRoute
  '/w/$workspaceId/credits/caps': typeof WsWWorkspaceIdCreditsCapsRoute
  '/w/$workspaceId/credits/overview': typeof WsWWorkspaceIdCreditsOverviewRoute
  '/w/$workspaceId/credits/usage': typeof WsWWorkspaceIdCreditsUsageRoute
  '/w/$workspaceId/members/seats': typeof WsWWorkspaceIdMembersSeatsRoute
  '/w/$workspaceId/seats-billing/billing': typeof WsWWorkspaceIdSeatsBillingBillingRoute
  '/w/$workspaceId/seats-billing/payment': typeof WsWWorkspaceIdSeatsBillingPaymentRoute
  '/w/$workspaceId/seats-billing/plan': typeof WsWWorkspaceIdSeatsBillingPlanRoute
  '/w/$workspaceId/seats-billing/seats': typeof WsWWorkspaceIdSeatsBillingSeatsRoute
  '/w/$workspaceId/billing': typeof WsWWorkspaceIdBillingIndexRoute
  '/w/$workspaceId/brands': typeof WsWWorkspaceIdBrandsIndexRoute
  '/w/$workspaceId/credits': typeof WsWWorkspaceIdCreditsIndexRoute
  '/w/$workspaceId/projects': typeof WsWWorkspaceIdProjectsIndexRoute
  '/w/$workspaceId/seats-billing': typeof WsWWorkspaceIdSeatsBillingIndexRoute
  '/w/$workspaceId/brands/$brandId/access': typeof WsWWorkspaceIdBrandsBrandIdAccessRoute
  '/w/$workspaceId/brands/$brandId/playbook': typeof WsWWorkspaceIdBrandsBrandIdPlaybookRoute
  '/w/$workspaceId/brands/$brandId/settings': typeof WsWWorkspaceIdBrandsBrandIdSettingsRoute
  '/w/$workspaceId/projects/$projectId/access': typeof WsWWorkspaceIdProjectsProjectIdAccessRoute
  '/w/$workspaceId/brands/$brandId': typeof WsWWorkspaceIdBrandsBrandIdIndexRoute
  '/w/$workspaceId/projects/$projectId': typeof WsWWorkspaceIdProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_ws': typeof WsRouteWithChildren
  '/dashboard-mock': typeof DashboardMockRoute
  '/dev-sim': typeof DevSimRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_app/$projectId': typeof AppProjectIdRouteWithChildren
  '/_app/agents': typeof AppAgentsRoute
  '/_app/brands': typeof AppBrandsRoute
  '/_app/buying-plan': typeof AppBuyingPlanRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/forbidden': typeof AppForbiddenRoute
  '/_app/projects': typeof AppProjectsRoute
  '/_ws/create-workspace': typeof WsCreateWorkspaceRoute
  '/_ws/invite-members': typeof WsInviteMembersRoute
  '/_ws/no-access': typeof WsNoAccessRoute
  '/_ws/workspaces': typeof WsWorkspacesRouteWithChildren
  '/join/$token': typeof JoinTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/$projectId/$': typeof AppProjectIdSplatRoute
  '/_app/$projectId/$agentId': typeof AppProjectIdAgentIdRouteWithChildren
  '/_app/$projectId/memory': typeof AppProjectIdMemoryRoute
  '/_ws/w/$workspaceId': typeof WsWWorkspaceIdRouteWithChildren
  '/_ws/workspaces/open': typeof WsWorkspacesOpenRoute
  '/feedback/$feedbackId/image': typeof FeedbackFeedbackIdImageRoute
  '/public/artifacts/$artifactId': typeof PublicArtifactsArtifactIdRoute
  '/_app/$projectId/': typeof AppProjectIdIndexRoute
  '/_ws/workspaces/': typeof WsWorkspacesIndexRoute
  '/_app/$projectId/$agentId/$': typeof AppProjectIdAgentIdSplatRoute
  '/_app/$projectId/objects/$objectId': typeof AppProjectIdObjectsObjectIdRoute
  '/_ws/w/$workspaceId/billing': typeof WsWWorkspaceIdBillingRouteWithChildren
  '/_ws/w/$workspaceId/brands': typeof WsWWorkspaceIdBrandsRouteWithChildren
  '/_ws/w/$workspaceId/connected-apps': typeof WsWWorkspaceIdConnectedAppsRoute
  '/_ws/w/$workspaceId/credits': typeof WsWWorkspaceIdCreditsRouteWithChildren
  '/_ws/w/$workspaceId/members': typeof WsWWorkspaceIdMembersRouteWithChildren
  '/_ws/w/$workspaceId/notifications': typeof WsWWorkspaceIdNotificationsRoute
  '/_ws/w/$workspaceId/overview': typeof WsWWorkspaceIdOverviewRoute
  '/_ws/w/$workspaceId/projects': typeof WsWWorkspaceIdProjectsRouteWithChildren
  '/_ws/w/$workspaceId/requests': typeof WsWWorkspaceIdRequestsRoute
  '/_ws/w/$workspaceId/seats-billing': typeof WsWWorkspaceIdSeatsBillingRouteWithChildren
  '/_ws/w/$workspaceId/settings': typeof WsWWorkspaceIdSettingsRoute
  '/_app/$projectId/$agentId/': typeof AppProjectIdAgentIdIndexRoute
  '/_ws/w/$workspaceId/': typeof WsWWorkspaceIdIndexRoute
  '/_app/$projectId/$agentId/documents/$documentId': typeof AppProjectIdAgentIdDocumentsDocumentIdRoute
  '/_ws/w/$workspaceId/billing/payment': typeof WsWWorkspaceIdBillingPaymentRoute
  '/_ws/w/$workspaceId/billing/plan': typeof WsWWorkspaceIdBillingPlanRoute
  '/_ws/w/$workspaceId/brands/$brandId': typeof WsWWorkspaceIdBrandsBrandIdRouteWithChildren
  '/_ws/w/$workspaceId/credits/allocation': typeof WsWWorkspaceIdCreditsAllocationRoute
  '/_ws/w/$workspaceId/credits/caps': typeof WsWWorkspaceIdCreditsCapsRoute
  '/_ws/w/$workspaceId/credits/overview': typeof WsWWorkspaceIdCreditsOverviewRoute
  '/_ws/w/$workspaceId/credits/usage': typeof WsWWorkspaceIdCreditsUsageRoute
  '/_ws/w/$workspaceId/members/seats': typeof WsWWorkspaceIdMembersSeatsRoute
  '/_ws/w/$workspaceId/projects/$projectId': typeof WsWWorkspaceIdProjectsProjectIdRouteWithChildren
  '/_ws/w/$workspaceId/seats-billing/billing': typeof WsWWorkspaceIdSeatsBillingBillingRoute
  '/_ws/w/$workspaceId/seats-billing/payment': typeof WsWWorkspaceIdSeatsBillingPaymentRoute
  '/_ws/w/$workspaceId/seats-billing/plan': typeof WsWWorkspaceIdSeatsBillingPlanRoute
  '/_ws/w/$workspaceId/seats-billing/seats': typeof WsWWorkspaceIdSeatsBillingSeatsRoute
  '/_ws/w/$workspaceId/billing/': typeof WsWWorkspaceIdBillingIndexRoute
  '/_ws/w/$workspaceId/brands/': typeof WsWWorkspaceIdBrandsIndexRoute
  '/_ws/w/$workspaceId/credits/': typeof WsWWorkspaceIdCreditsIndexRoute
  '/_ws/w/$workspaceId/projects/': typeof WsWWorkspaceIdProjectsIndexRoute
  '/_ws/w/$workspaceId/seats-billing/': typeof WsWWorkspaceIdSeatsBillingIndexRoute
  '/_ws/w/$workspaceId/brands/$brandId/access': typeof WsWWorkspaceIdBrandsBrandIdAccessRoute
  '/_ws/w/$workspaceId/brands/$brandId/playbook': typeof WsWWorkspaceIdBrandsBrandIdPlaybookRoute
  '/_ws/w/$workspaceId/brands/$brandId/settings': typeof WsWWorkspaceIdBrandsBrandIdSettingsRoute
  '/_ws/w/$workspaceId/projects/$projectId/access': typeof WsWWorkspaceIdProjectsProjectIdAccessRoute
  '/_ws/w/$workspaceId/brands/$brandId/': typeof WsWWorkspaceIdBrandsBrandIdIndexRoute
  '/_ws/w/$workspaceId/projects/$projectId/': typeof WsWWorkspaceIdProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard-mock'
    | '/dev-sim'
    | '/login'
    | '/signup'
    | '/$projectId'
    | '/agents'
    | '/brands'
    | '/buying-plan'
    | '/dashboard'
    | '/forbidden'
    | '/projects'
    | '/create-workspace'
    | '/invite-members'
    | '/no-access'
    | '/workspaces'
    | '/join/$token'
    | '/$projectId/$'
    | '/$projectId/$agentId'
    | '/$projectId/memory'
    | '/w/$workspaceId'
    | '/workspaces/open'
    | '/feedback/$feedbackId/image'
    | '/public/artifacts/$artifactId'
    | '/$projectId/'
    | '/workspaces/'
    | '/$projectId/$agentId/$'
    | '/$projectId/objects/$objectId'
    | '/w/$workspaceId/billing'
    | '/w/$workspaceId/brands'
    | '/w/$workspaceId/connected-apps'
    | '/w/$workspaceId/credits'
    | '/w/$workspaceId/members'
    | '/w/$workspaceId/notifications'
    | '/w/$workspaceId/overview'
    | '/w/$workspaceId/projects'
    | '/w/$workspaceId/requests'
    | '/w/$workspaceId/seats-billing'
    | '/w/$workspaceId/settings'
    | '/$projectId/$agentId/'
    | '/w/$workspaceId/'
    | '/$projectId/$agentId/documents/$documentId'
    | '/w/$workspaceId/billing/payment'
    | '/w/$workspaceId/billing/plan'
    | '/w/$workspaceId/brands/$brandId'
    | '/w/$workspaceId/credits/allocation'
    | '/w/$workspaceId/credits/caps'
    | '/w/$workspaceId/credits/overview'
    | '/w/$workspaceId/credits/usage'
    | '/w/$workspaceId/members/seats'
    | '/w/$workspaceId/projects/$projectId'
    | '/w/$workspaceId/seats-billing/billing'
    | '/w/$workspaceId/seats-billing/payment'
    | '/w/$workspaceId/seats-billing/plan'
    | '/w/$workspaceId/seats-billing/seats'
    | '/w/$workspaceId/billing/'
    | '/w/$workspaceId/brands/'
    | '/w/$workspaceId/credits/'
    | '/w/$workspaceId/projects/'
    | '/w/$workspaceId/seats-billing/'
    | '/w/$workspaceId/brands/$brandId/access'
    | '/w/$workspaceId/brands/$brandId/playbook'
    | '/w/$workspaceId/brands/$brandId/settings'
    | '/w/$workspaceId/projects/$projectId/access'
    | '/w/$workspaceId/brands/$brandId/'
    | '/w/$workspaceId/projects/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard-mock'
    | '/dev-sim'
    | '/login'
    | '/signup'
    | '/agents'
    | '/brands'
    | '/buying-plan'
    | '/dashboard'
    | '/forbidden'
    | '/projects'
    | '/create-workspace'
    | '/invite-members'
    | '/no-access'
    | '/join/$token'
    | '/$projectId/$'
    | '/$projectId/memory'
    | '/workspaces/open'
    | '/feedback/$feedbackId/image'
    | '/public/artifacts/$artifactId'
    | '/$projectId'
    | '/workspaces'
    | '/$projectId/$agentId/$'
    | '/$projectId/objects/$objectId'
    | '/w/$workspaceId/connected-apps'
    | '/w/$workspaceId/members'
    | '/w/$workspaceId/notifications'
    | '/w/$workspaceId/overview'
    | '/w/$workspaceId/requests'
    | '/w/$workspaceId/settings'
    | '/$projectId/$agentId'
    | '/w/$workspaceId'
    | '/$projectId/$agentId/documents/$documentId'
    | '/w/$workspaceId/billing/payment'
    | '/w/$workspaceId/billing/plan'
    | '/w/$workspaceId/credits/allocation'
    | '/w/$workspaceId/credits/caps'
    | '/w/$workspaceId/credits/overview'
    | '/w/$workspaceId/credits/usage'
    | '/w/$workspaceId/members/seats'
    | '/w/$workspaceId/seats-billing/billing'
    | '/w/$workspaceId/seats-billing/payment'
    | '/w/$workspaceId/seats-billing/plan'
    | '/w/$workspaceId/seats-billing/seats'
    | '/w/$workspaceId/billing'
    | '/w/$workspaceId/brands'
    | '/w/$workspaceId/credits'
    | '/w/$workspaceId/projects'
    | '/w/$workspaceId/seats-billing'
    | '/w/$workspaceId/brands/$brandId/access'
    | '/w/$workspaceId/brands/$brandId/playbook'
    | '/w/$workspaceId/brands/$brandId/settings'
    | '/w/$workspaceId/projects/$projectId/access'
    | '/w/$workspaceId/brands/$brandId'
    | '/w/$workspaceId/projects/$projectId'
  id:
    | '__root__'
    | '/_app'
    | '/_ws'
    | '/dashboard-mock'
    | '/dev-sim'
    | '/login'
    | '/signup'
    | '/_app/$projectId'
    | '/_app/agents'
    | '/_app/brands'
    | '/_app/buying-plan'
    | '/_app/dashboard'
    | '/_app/forbidden'
    | '/_app/projects'
    | '/_ws/create-workspace'
    | '/_ws/invite-members'
    | '/_ws/no-access'
    | '/_ws/workspaces'
    | '/join/$token'
    | '/_app/'
    | '/_app/$projectId/$'
    | '/_app/$projectId/$agentId'
    | '/_app/$projectId/memory'
    | '/_ws/w/$workspaceId'
    | '/_ws/workspaces/open'
    | '/feedback/$feedbackId/image'
    | '/public/artifacts/$artifactId'
    | '/_app/$projectId/'
    | '/_ws/workspaces/'
    | '/_app/$projectId/$agentId/$'
    | '/_app/$projectId/objects/$objectId'
    | '/_ws/w/$workspaceId/billing'
    | '/_ws/w/$workspaceId/brands'
    | '/_ws/w/$workspaceId/connected-apps'
    | '/_ws/w/$workspaceId/credits'
    | '/_ws/w/$workspaceId/members'
    | '/_ws/w/$workspaceId/notifications'
    | '/_ws/w/$workspaceId/overview'
    | '/_ws/w/$workspaceId/projects'
    | '/_ws/w/$workspaceId/requests'
    | '/_ws/w/$workspaceId/seats-billing'
    | '/_ws/w/$workspaceId/settings'
    | '/_app/$projectId/$agentId/'
    | '/_ws/w/$workspaceId/'
    | '/_app/$projectId/$agentId/documents/$documentId'
    | '/_ws/w/$workspaceId/billing/payment'
    | '/_ws/w/$workspaceId/billing/plan'
    | '/_ws/w/$workspaceId/brands/$brandId'
    | '/_ws/w/$workspaceId/credits/allocation'
    | '/_ws/w/$workspaceId/credits/caps'
    | '/_ws/w/$workspaceId/credits/overview'
    | '/_ws/w/$workspaceId/credits/usage'
    | '/_ws/w/$workspaceId/members/seats'
    | '/_ws/w/$workspaceId/projects/$projectId'
    | '/_ws/w/$workspaceId/seats-billing/billing'
    | '/_ws/w/$workspaceId/seats-billing/payment'
    | '/_ws/w/$workspaceId/seats-billing/plan'
    | '/_ws/w/$workspaceId/seats-billing/seats'
    | '/_ws/w/$workspaceId/billing/'
    | '/_ws/w/$workspaceId/brands/'
    | '/_ws/w/$workspaceId/credits/'
    | '/_ws/w/$workspaceId/projects/'
    | '/_ws/w/$workspaceId/seats-billing/'
    | '/_ws/w/$workspaceId/brands/$brandId/access'
    | '/_ws/w/$workspaceId/brands/$brandId/playbook'
    | '/_ws/w/$workspaceId/brands/$brandId/settings'
    | '/_ws/w/$workspaceId/projects/$projectId/access'
    | '/_ws/w/$workspaceId/brands/$brandId/'
    | '/_ws/w/$workspaceId/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  WsRoute: typeof WsRouteWithChildren
  DashboardMockRoute: typeof DashboardMockRoute
  DevSimRoute: typeof DevSimRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  JoinTokenRoute: typeof JoinTokenRoute
  FeedbackFeedbackIdImageRoute: typeof FeedbackFeedbackIdImageRoute
  PublicArtifactsArtifactIdRoute: typeof PublicArtifactsArtifactIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev-sim': {
      id: '/dev-sim'
      path: '/dev-sim'
      fullPath: '/dev-sim'
      preLoaderRoute: typeof DevSimRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard-mock': {
      id: '/dashboard-mock'
      path: '/dashboard-mock'
      fullPath: '/dashboard-mock'
      preLoaderRoute: typeof DashboardMockRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_ws': {
      id: '/_ws'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof WsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_ws/workspaces': {
      id: '/_ws/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof WsWorkspacesRouteImport
      parentRoute: typeof WsRoute
    }
    '/_ws/no-access': {
      id: '/_ws/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof WsNoAccessRouteImport
      parentRoute: typeof WsRoute
    }
    '/_ws/invite-members': {
      id: '/_ws/invite-members'
      path: '/invite-members'
      fullPath: '/invite-members'
      preLoaderRoute: typeof WsInviteMembersRouteImport
      parentRoute: typeof WsRoute
    }
    '/_ws/create-workspace': {
      id: '/_ws/create-workspace'
      path: '/create-workspace'
      fullPath: '/create-workspace'
      preLoaderRoute: typeof WsCreateWorkspaceRouteImport
      parentRoute: typeof WsRoute
    }
    '/_app/projects': {
      id: '/_app/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forbidden': {
      id: '/_app/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof AppForbiddenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/buying-plan': {
      id: '/_app/buying-plan'
      path: '/buying-plan'
      fullPath: '/buying-plan'
      preLoaderRoute: typeof AppBuyingPlanRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brands': {
      id: '/_app/brands'
      path: '/brands'
      fullPath: '/brands'
      preLoaderRoute: typeof AppBrandsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents': {
      id: '/_app/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AppAgentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$projectId': {
      id: '/_app/$projectId'
      path: '/$projectId'
      fullPath: '/$projectId'
      preLoaderRoute: typeof AppProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_ws/workspaces/': {
      id: '/_ws/workspaces/'
      path: '/'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof WsWorkspacesIndexRouteImport
      parentRoute: typeof WsWorkspacesRoute
    }
    '/_app/$projectId/': {
      id: '/_app/$projectId/'
      path: '/'
      fullPath: '/$projectId/'
      preLoaderRoute: typeof AppProjectIdIndexRouteImport
      parentRoute: typeof AppProjectIdRoute
    }
    '/public/artifacts/$artifactId': {
      id: '/public/artifacts/$artifactId'
      path: '/public/artifacts/$artifactId'
      fullPath: '/public/artifacts/$artifactId'
      preLoaderRoute: typeof PublicArtifactsArtifactIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/$feedbackId/image': {
      id: '/feedback/$feedbackId/image'
      path: '/feedback/$feedbackId/image'
      fullPath: '/feedback/$feedbackId/image'
      preLoaderRoute: typeof FeedbackFeedbackIdImageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_ws/workspaces/open': {
      id: '/_ws/workspaces/open'
      path: '/open'
      fullPath: '/workspaces/open'
      preLoaderRoute: typeof WsWorkspacesOpenRouteImport
      parentRoute: typeof WsWorkspacesRoute
    }
    '/_ws/w/$workspaceId': {
      id: '/_ws/w/$workspaceId'
      path: '/w/$workspaceId'
      fullPath: '/w/$workspaceId'
      preLoaderRoute: typeof WsWWorkspaceIdRouteImport
      parentRoute: typeof WsRoute
    }
    '/_app/$projectId/memory': {
      id: '/_app/$projectId/memory'
      path: '/memory'
      fullPath: '/$projectId/memory'
      preLoaderRoute: typeof AppProjectIdMemoryRouteImport
      parentRoute: typeof AppProjectIdRoute
    }
    '/_app/$projectId/$agentId': {
      id: '/_app/$projectId/$agentId'
      path: '/$agentId'
      fullPath: '/$projectId/$agentId'
      preLoaderRoute: typeof AppProjectIdAgentIdRouteImport
      parentRoute: typeof AppProjectIdRoute
    }
    '/_app/$projectId/$': {
      id: '/_app/$projectId/$'
      path: '/$'
      fullPath: '/$projectId/$'
      preLoaderRoute: typeof AppProjectIdSplatRouteImport
      parentRoute: typeof AppProjectIdRoute
    }
    '/_ws/w/$workspaceId/': {
      id: '/_ws/w/$workspaceId/'
      path: '/'
      fullPath: '/w/$workspaceId/'
      preLoaderRoute: typeof WsWWorkspaceIdIndexRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_app/$projectId/$agentId/': {
      id: '/_app/$projectId/$agentId/'
      path: '/'
      fullPath: '/$projectId/$agentId/'
      preLoaderRoute: typeof AppProjectIdAgentIdIndexRouteImport
      parentRoute: typeof AppProjectIdAgentIdRoute
    }
    '/_ws/w/$workspaceId/settings': {
      id: '/_ws/w/$workspaceId/settings'
      path: '/settings'
      fullPath: '/w/$workspaceId/settings'
      preLoaderRoute: typeof WsWWorkspaceIdSettingsRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_ws/w/$workspaceId/seats-billing': {
      id: '/_ws/w/$workspaceId/seats-billing'
      path: '/seats-billing'
      fullPath: '/w/$workspaceId/seats-billing'
      preLoaderRoute: typeof WsWWorkspaceIdSeatsBillingRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_ws/w/$workspaceId/requests': {
      id: '/_ws/w/$workspaceId/requests'
      path: '/requests'
      fullPath: '/w/$workspaceId/requests'
      preLoaderRoute: typeof WsWWorkspaceIdRequestsRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_ws/w/$workspaceId/projects': {
      id: '/_ws/w/$workspaceId/projects'
      path: '/projects'
      fullPath: '/w/$workspaceId/projects'
      preLoaderRoute: typeof WsWWorkspaceIdProjectsRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_ws/w/$workspaceId/overview': {
      id: '/_ws/w/$workspaceId/overview'
      path: '/overview'
      fullPath: '/w/$workspaceId/overview'
      preLoaderRoute: typeof WsWWorkspaceIdOverviewRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_ws/w/$workspaceId/notifications': {
      id: '/_ws/w/$workspaceId/notifications'
      path: '/notifications'
      fullPath: '/w/$workspaceId/notifications'
      preLoaderRoute: typeof WsWWorkspaceIdNotificationsRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_ws/w/$workspaceId/members': {
      id: '/_ws/w/$workspaceId/members'
      path: '/members'
      fullPath: '/w/$workspaceId/members'
      preLoaderRoute: typeof WsWWorkspaceIdMembersRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_ws/w/$workspaceId/credits': {
      id: '/_ws/w/$workspaceId/credits'
      path: '/credits'
      fullPath: '/w/$workspaceId/credits'
      preLoaderRoute: typeof WsWWorkspaceIdCreditsRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_ws/w/$workspaceId/connected-apps': {
      id: '/_ws/w/$workspaceId/connected-apps'
      path: '/connected-apps'
      fullPath: '/w/$workspaceId/connected-apps'
      preLoaderRoute: typeof WsWWorkspaceIdConnectedAppsRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_ws/w/$workspaceId/brands': {
      id: '/_ws/w/$workspaceId/brands'
      path: '/brands'
      fullPath: '/w/$workspaceId/brands'
      preLoaderRoute: typeof WsWWorkspaceIdBrandsRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_ws/w/$workspaceId/billing': {
      id: '/_ws/w/$workspaceId/billing'
      path: '/billing'
      fullPath: '/w/$workspaceId/billing'
      preLoaderRoute: typeof WsWWorkspaceIdBillingRouteImport
      parentRoute: typeof WsWWorkspaceIdRoute
    }
    '/_app/$projectId/objects/$objectId': {
      id: '/_app/$projectId/objects/$objectId'
      path: '/objects/$objectId'
      fullPath: '/$projectId/objects/$objectId'
      preLoaderRoute: typeof AppProjectIdObjectsObjectIdRouteImport
      parentRoute: typeof AppProjectIdRoute
    }
    '/_app/$projectId/$agentId/$': {
      id: '/_app/$projectId/$agentId/$'
      path: '/$'
      fullPath: '/$projectId/$agentId/$'
      preLoaderRoute: typeof AppProjectIdAgentIdSplatRouteImport
      parentRoute: typeof AppProjectIdAgentIdRoute
    }
    '/_ws/w/$workspaceId/seats-billing/': {
      id: '/_ws/w/$workspaceId/seats-billing/'
      path: '/'
      fullPath: '/w/$workspaceId/seats-billing/'
      preLoaderRoute: typeof WsWWorkspaceIdSeatsBillingIndexRouteImport
      parentRoute: typeof WsWWorkspaceIdSeatsBillingRoute
    }
    '/_ws/w/$workspaceId/projects/': {
      id: '/_ws/w/$workspaceId/projects/'
      path: '/'
      fullPath: '/w/$workspaceId/projects/'
      preLoaderRoute: typeof WsWWorkspaceIdProjectsIndexRouteImport
      parentRoute: typeof WsWWorkspaceIdProjectsRoute
    }
    '/_ws/w/$workspaceId/credits/': {
      id: '/_ws/w/$workspaceId/credits/'
      path: '/'
      fullPath: '/w/$workspaceId/credits/'
      preLoaderRoute: typeof WsWWorkspaceIdCreditsIndexRouteImport
      parentRoute: typeof WsWWorkspaceIdCreditsRoute
    }
    '/_ws/w/$workspaceId/brands/': {
      id: '/_ws/w/$workspaceId/brands/'
      path: '/'
      fullPath: '/w/$workspaceId/brands/'
      preLoaderRoute: typeof WsWWorkspaceIdBrandsIndexRouteImport
      parentRoute: typeof WsWWorkspaceIdBrandsRoute
    }
    '/_ws/w/$workspaceId/billing/': {
      id: '/_ws/w/$workspaceId/billing/'
      path: '/'
      fullPath: '/w/$workspaceId/billing/'
      preLoaderRoute: typeof WsWWorkspaceIdBillingIndexRouteImport
      parentRoute: typeof WsWWorkspaceIdBillingRoute
    }
    '/_ws/w/$workspaceId/seats-billing/seats': {
      id: '/_ws/w/$workspaceId/seats-billing/seats'
      path: '/seats'
      fullPath: '/w/$workspaceId/seats-billing/seats'
      preLoaderRoute: typeof WsWWorkspaceIdSeatsBillingSeatsRouteImport
      parentRoute: typeof WsWWorkspaceIdSeatsBillingRoute
    }
    '/_ws/w/$workspaceId/seats-billing/plan': {
      id: '/_ws/w/$workspaceId/seats-billing/plan'
      path: '/plan'
      fullPath: '/w/$workspaceId/seats-billing/plan'
      preLoaderRoute: typeof WsWWorkspaceIdSeatsBillingPlanRouteImport
      parentRoute: typeof WsWWorkspaceIdSeatsBillingRoute
    }
    '/_ws/w/$workspaceId/seats-billing/payment': {
      id: '/_ws/w/$workspaceId/seats-billing/payment'
      path: '/payment'
      fullPath: '/w/$workspaceId/seats-billing/payment'
      preLoaderRoute: typeof WsWWorkspaceIdSeatsBillingPaymentRouteImport
      parentRoute: typeof WsWWorkspaceIdSeatsBillingRoute
    }
    '/_ws/w/$workspaceId/seats-billing/billing': {
      id: '/_ws/w/$workspaceId/seats-billing/billing'
      path: '/billing'
      fullPath: '/w/$workspaceId/seats-billing/billing'
      preLoaderRoute: typeof WsWWorkspaceIdSeatsBillingBillingRouteImport
      parentRoute: typeof WsWWorkspaceIdSeatsBillingRoute
    }
    '/_ws/w/$workspaceId/projects/$projectId': {
      id: '/_ws/w/$workspaceId/projects/$projectId'
      path: '/$projectId'
      fullPath: '/w/$workspaceId/projects/$projectId'
      preLoaderRoute: typeof WsWWorkspaceIdProjectsProjectIdRouteImport
      parentRoute: typeof WsWWorkspaceIdProjectsRoute
    }
    '/_ws/w/$workspaceId/members/seats': {
      id: '/_ws/w/$workspaceId/members/seats'
      path: '/seats'
      fullPath: '/w/$workspaceId/members/seats'
      preLoaderRoute: typeof WsWWorkspaceIdMembersSeatsRouteImport
      parentRoute: typeof WsWWorkspaceIdMembersRoute
    }
    '/_ws/w/$workspaceId/credits/usage': {
      id: '/_ws/w/$workspaceId/credits/usage'
      path: '/usage'
      fullPath: '/w/$workspaceId/credits/usage'
      preLoaderRoute: typeof WsWWorkspaceIdCreditsUsageRouteImport
      parentRoute: typeof WsWWorkspaceIdCreditsRoute
    }
    '/_ws/w/$workspaceId/credits/overview': {
      id: '/_ws/w/$workspaceId/credits/overview'
      path: '/overview'
      fullPath: '/w/$workspaceId/credits/overview'
      preLoaderRoute: typeof WsWWorkspaceIdCreditsOverviewRouteImport
      parentRoute: typeof WsWWorkspaceIdCreditsRoute
    }
    '/_ws/w/$workspaceId/credits/caps': {
      id: '/_ws/w/$workspaceId/credits/caps'
      path: '/caps'
      fullPath: '/w/$workspaceId/credits/caps'
      preLoaderRoute: typeof WsWWorkspaceIdCreditsCapsRouteImport
      parentRoute: typeof WsWWorkspaceIdCreditsRoute
    }
    '/_ws/w/$workspaceId/credits/allocation': {
      id: '/_ws/w/$workspaceId/credits/allocation'
      path: '/allocation'
      fullPath: '/w/$workspaceId/credits/allocation'
      preLoaderRoute: typeof WsWWorkspaceIdCreditsAllocationRouteImport
      parentRoute: typeof WsWWorkspaceIdCreditsRoute
    }
    '/_ws/w/$workspaceId/brands/$brandId': {
      id: '/_ws/w/$workspaceId/brands/$brandId'
      path: '/$brandId'
      fullPath: '/w/$workspaceId/brands/$brandId'
      preLoaderRoute: typeof WsWWorkspaceIdBrandsBrandIdRouteImport
      parentRoute: typeof WsWWorkspaceIdBrandsRoute
    }
    '/_ws/w/$workspaceId/billing/plan': {
      id: '/_ws/w/$workspaceId/billing/plan'
      path: '/plan'
      fullPath: '/w/$workspaceId/billing/plan'
      preLoaderRoute: typeof WsWWorkspaceIdBillingPlanRouteImport
      parentRoute: typeof WsWWorkspaceIdBillingRoute
    }
    '/_ws/w/$workspaceId/billing/payment': {
      id: '/_ws/w/$workspaceId/billing/payment'
      path: '/payment'
      fullPath: '/w/$workspaceId/billing/payment'
      preLoaderRoute: typeof WsWWorkspaceIdBillingPaymentRouteImport
      parentRoute: typeof WsWWorkspaceIdBillingRoute
    }
    '/_app/$projectId/$agentId/documents/$documentId': {
      id: '/_app/$projectId/$agentId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/$projectId/$agentId/documents/$documentId'
      preLoaderRoute: typeof AppProjectIdAgentIdDocumentsDocumentIdRouteImport
      parentRoute: typeof AppProjectIdAgentIdRoute
    }
    '/_ws/w/$workspaceId/projects/$projectId/': {
      id: '/_ws/w/$workspaceId/projects/$projectId/'
      path: '/'
      fullPath: '/w/$workspaceId/projects/$projectId/'
      preLoaderRoute: typeof WsWWorkspaceIdProjectsProjectIdIndexRouteImport
      parentRoute: typeof WsWWorkspaceIdProjectsProjectIdRoute
    }
    '/_ws/w/$workspaceId/brands/$brandId/': {
      id: '/_ws/w/$workspaceId/brands/$brandId/'
      path: '/'
      fullPath: '/w/$workspaceId/brands/$brandId/'
      preLoaderRoute: typeof WsWWorkspaceIdBrandsBrandIdIndexRouteImport
      parentRoute: typeof WsWWorkspaceIdBrandsBrandIdRoute
    }
    '/_ws/w/$workspaceId/projects/$projectId/access': {
      id: '/_ws/w/$workspaceId/projects/$projectId/access'
      path: '/access'
      fullPath: '/w/$workspaceId/projects/$projectId/access'
      preLoaderRoute: typeof WsWWorkspaceIdProjectsProjectIdAccessRouteImport
      parentRoute: typeof WsWWorkspaceIdProjectsProjectIdRoute
    }
    '/_ws/w/$workspaceId/brands/$brandId/settings': {
      id: '/_ws/w/$workspaceId/brands/$brandId/settings'
      path: '/settings'
      fullPath: '/w/$workspaceId/brands/$brandId/settings'
      preLoaderRoute: typeof WsWWorkspaceIdBrandsBrandIdSettingsRouteImport
      parentRoute: typeof WsWWorkspaceIdBrandsBrandIdRoute
    }
    '/_ws/w/$workspaceId/brands/$brandId/playbook': {
      id: '/_ws/w/$workspaceId/brands/$brandId/playbook'
      path: '/playbook'
      fullPath: '/w/$workspaceId/brands/$brandId/playbook'
      preLoaderRoute: typeof WsWWorkspaceIdBrandsBrandIdPlaybookRouteImport
      parentRoute: typeof WsWWorkspaceIdBrandsBrandIdRoute
    }
    '/_ws/w/$workspaceId/brands/$brandId/access': {
      id: '/_ws/w/$workspaceId/brands/$brandId/access'
      path: '/access'
      fullPath: '/w/$workspaceId/brands/$brandId/access'
      preLoaderRoute: typeof WsWWorkspaceIdBrandsBrandIdAccessRouteImport
      parentRoute: typeof WsWWorkspaceIdBrandsBrandIdRoute
    }
  }
}

interface AppProjectIdAgentIdRouteChildren {
  AppProjectIdAgentIdSplatRoute: typeof AppProjectIdAgentIdSplatRoute
  AppProjectIdAgentIdIndexRoute: typeof AppProjectIdAgentIdIndexRoute
  AppProjectIdAgentIdDocumentsDocumentIdRoute: typeof AppProjectIdAgentIdDocumentsDocumentIdRoute
}

const AppProjectIdAgentIdRouteChildren: AppProjectIdAgentIdRouteChildren = {
  AppProjectIdAgentIdSplatRoute: AppProjectIdAgentIdSplatRoute,
  AppProjectIdAgentIdIndexRoute: AppProjectIdAgentIdIndexRoute,
  AppProjectIdAgentIdDocumentsDocumentIdRoute:
    AppProjectIdAgentIdDocumentsDocumentIdRoute,
}

const AppProjectIdAgentIdRouteWithChildren =
  AppProjectIdAgentIdRoute._addFileChildren(AppProjectIdAgentIdRouteChildren)

interface AppProjectIdRouteChildren {
  AppProjectIdSplatRoute: typeof AppProjectIdSplatRoute
  AppProjectIdAgentIdRoute: typeof AppProjectIdAgentIdRouteWithChildren
  AppProjectIdMemoryRoute: typeof AppProjectIdMemoryRoute
  AppProjectIdIndexRoute: typeof AppProjectIdIndexRoute
  AppProjectIdObjectsObjectIdRoute: typeof AppProjectIdObjectsObjectIdRoute
}

const AppProjectIdRouteChildren: AppProjectIdRouteChildren = {
  AppProjectIdSplatRoute: AppProjectIdSplatRoute,
  AppProjectIdAgentIdRoute: AppProjectIdAgentIdRouteWithChildren,
  AppProjectIdMemoryRoute: AppProjectIdMemoryRoute,
  AppProjectIdIndexRoute: AppProjectIdIndexRoute,
  AppProjectIdObjectsObjectIdRoute: AppProjectIdObjectsObjectIdRoute,
}

const AppProjectIdRouteWithChildren = AppProjectIdRoute._addFileChildren(
  AppProjectIdRouteChildren,
)

interface AppRouteChildren {
  AppProjectIdRoute: typeof AppProjectIdRouteWithChildren
  AppAgentsRoute: typeof AppAgentsRoute
  AppBrandsRoute: typeof AppBrandsRoute
  AppBuyingPlanRoute: typeof AppBuyingPlanRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppForbiddenRoute: typeof AppForbiddenRoute
  AppProjectsRoute: typeof AppProjectsRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppProjectIdRoute: AppProjectIdRouteWithChildren,
  AppAgentsRoute: AppAgentsRoute,
  AppBrandsRoute: AppBrandsRoute,
  AppBuyingPlanRoute: AppBuyingPlanRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppForbiddenRoute: AppForbiddenRoute,
  AppProjectsRoute: AppProjectsRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface WsWorkspacesRouteChildren {
  WsWorkspacesOpenRoute: typeof WsWorkspacesOpenRoute
  WsWorkspacesIndexRoute: typeof WsWorkspacesIndexRoute
}

const WsWorkspacesRouteChildren: WsWorkspacesRouteChildren = {
  WsWorkspacesOpenRoute: WsWorkspacesOpenRoute,
  WsWorkspacesIndexRoute: WsWorkspacesIndexRoute,
}

const WsWorkspacesRouteWithChildren = WsWorkspacesRoute._addFileChildren(
  WsWorkspacesRouteChildren,
)

interface WsWWorkspaceIdBillingRouteChildren {
  WsWWorkspaceIdBillingPaymentRoute: typeof WsWWorkspaceIdBillingPaymentRoute
  WsWWorkspaceIdBillingPlanRoute: typeof WsWWorkspaceIdBillingPlanRoute
  WsWWorkspaceIdBillingIndexRoute: typeof WsWWorkspaceIdBillingIndexRoute
}

const WsWWorkspaceIdBillingRouteChildren: WsWWorkspaceIdBillingRouteChildren = {
  WsWWorkspaceIdBillingPaymentRoute: WsWWorkspaceIdBillingPaymentRoute,
  WsWWorkspaceIdBillingPlanRoute: WsWWorkspaceIdBillingPlanRoute,
  WsWWorkspaceIdBillingIndexRoute: WsWWorkspaceIdBillingIndexRoute,
}

const WsWWorkspaceIdBillingRouteWithChildren =
  WsWWorkspaceIdBillingRoute._addFileChildren(
    WsWWorkspaceIdBillingRouteChildren,
  )

interface WsWWorkspaceIdBrandsBrandIdRouteChildren {
  WsWWorkspaceIdBrandsBrandIdAccessRoute: typeof WsWWorkspaceIdBrandsBrandIdAccessRoute
  WsWWorkspaceIdBrandsBrandIdPlaybookRoute: typeof WsWWorkspaceIdBrandsBrandIdPlaybookRoute
  WsWWorkspaceIdBrandsBrandIdSettingsRoute: typeof WsWWorkspaceIdBrandsBrandIdSettingsRoute
  WsWWorkspaceIdBrandsBrandIdIndexRoute: typeof WsWWorkspaceIdBrandsBrandIdIndexRoute
}

const WsWWorkspaceIdBrandsBrandIdRouteChildren: WsWWorkspaceIdBrandsBrandIdRouteChildren =
  {
    WsWWorkspaceIdBrandsBrandIdAccessRoute:
      WsWWorkspaceIdBrandsBrandIdAccessRoute,
    WsWWorkspaceIdBrandsBrandIdPlaybookRoute:
      WsWWorkspaceIdBrandsBrandIdPlaybookRoute,
    WsWWorkspaceIdBrandsBrandIdSettingsRoute:
      WsWWorkspaceIdBrandsBrandIdSettingsRoute,
    WsWWorkspaceIdBrandsBrandIdIndexRoute:
      WsWWorkspaceIdBrandsBrandIdIndexRoute,
  }

const WsWWorkspaceIdBrandsBrandIdRouteWithChildren =
  WsWWorkspaceIdBrandsBrandIdRoute._addFileChildren(
    WsWWorkspaceIdBrandsBrandIdRouteChildren,
  )

interface WsWWorkspaceIdBrandsRouteChildren {
  WsWWorkspaceIdBrandsBrandIdRoute: typeof WsWWorkspaceIdBrandsBrandIdRouteWithChildren
  WsWWorkspaceIdBrandsIndexRoute: typeof WsWWorkspaceIdBrandsIndexRoute
}

const WsWWorkspaceIdBrandsRouteChildren: WsWWorkspaceIdBrandsRouteChildren = {
  WsWWorkspaceIdBrandsBrandIdRoute:
    WsWWorkspaceIdBrandsBrandIdRouteWithChildren,
  WsWWorkspaceIdBrandsIndexRoute: WsWWorkspaceIdBrandsIndexRoute,
}

const WsWWorkspaceIdBrandsRouteWithChildren =
  WsWWorkspaceIdBrandsRoute._addFileChildren(WsWWorkspaceIdBrandsRouteChildren)

interface WsWWorkspaceIdCreditsRouteChildren {
  WsWWorkspaceIdCreditsAllocationRoute: typeof WsWWorkspaceIdCreditsAllocationRoute
  WsWWorkspaceIdCreditsCapsRoute: typeof WsWWorkspaceIdCreditsCapsRoute
  WsWWorkspaceIdCreditsOverviewRoute: typeof WsWWorkspaceIdCreditsOverviewRoute
  WsWWorkspaceIdCreditsUsageRoute: typeof WsWWorkspaceIdCreditsUsageRoute
  WsWWorkspaceIdCreditsIndexRoute: typeof WsWWorkspaceIdCreditsIndexRoute
}

const WsWWorkspaceIdCreditsRouteChildren: WsWWorkspaceIdCreditsRouteChildren = {
  WsWWorkspaceIdCreditsAllocationRoute: WsWWorkspaceIdCreditsAllocationRoute,
  WsWWorkspaceIdCreditsCapsRoute: WsWWorkspaceIdCreditsCapsRoute,
  WsWWorkspaceIdCreditsOverviewRoute: WsWWorkspaceIdCreditsOverviewRoute,
  WsWWorkspaceIdCreditsUsageRoute: WsWWorkspaceIdCreditsUsageRoute,
  WsWWorkspaceIdCreditsIndexRoute: WsWWorkspaceIdCreditsIndexRoute,
}

const WsWWorkspaceIdCreditsRouteWithChildren =
  WsWWorkspaceIdCreditsRoute._addFileChildren(
    WsWWorkspaceIdCreditsRouteChildren,
  )

interface WsWWorkspaceIdMembersRouteChildren {
  WsWWorkspaceIdMembersSeatsRoute: typeof WsWWorkspaceIdMembersSeatsRoute
}

const WsWWorkspaceIdMembersRouteChildren: WsWWorkspaceIdMembersRouteChildren = {
  WsWWorkspaceIdMembersSeatsRoute: WsWWorkspaceIdMembersSeatsRoute,
}

const WsWWorkspaceIdMembersRouteWithChildren =
  WsWWorkspaceIdMembersRoute._addFileChildren(
    WsWWorkspaceIdMembersRouteChildren,
  )

interface WsWWorkspaceIdProjectsProjectIdRouteChildren {
  WsWWorkspaceIdProjectsProjectIdAccessRoute: typeof WsWWorkspaceIdProjectsProjectIdAccessRoute
  WsWWorkspaceIdProjectsProjectIdIndexRoute: typeof WsWWorkspaceIdProjectsProjectIdIndexRoute
}

const WsWWorkspaceIdProjectsProjectIdRouteChildren: WsWWorkspaceIdProjectsProjectIdRouteChildren =
  {
    WsWWorkspaceIdProjectsProjectIdAccessRoute:
      WsWWorkspaceIdProjectsProjectIdAccessRoute,
    WsWWorkspaceIdProjectsProjectIdIndexRoute:
      WsWWorkspaceIdProjectsProjectIdIndexRoute,
  }

const WsWWorkspaceIdProjectsProjectIdRouteWithChildren =
  WsWWorkspaceIdProjectsProjectIdRoute._addFileChildren(
    WsWWorkspaceIdProjectsProjectIdRouteChildren,
  )

interface WsWWorkspaceIdProjectsRouteChildren {
  WsWWorkspaceIdProjectsProjectIdRoute: typeof WsWWorkspaceIdProjectsProjectIdRouteWithChildren
  WsWWorkspaceIdProjectsIndexRoute: typeof WsWWorkspaceIdProjectsIndexRoute
}

const WsWWorkspaceIdProjectsRouteChildren: WsWWorkspaceIdProjectsRouteChildren =
  {
    WsWWorkspaceIdProjectsProjectIdRoute:
      WsWWorkspaceIdProjectsProjectIdRouteWithChildren,
    WsWWorkspaceIdProjectsIndexRoute: WsWWorkspaceIdProjectsIndexRoute,
  }

const WsWWorkspaceIdProjectsRouteWithChildren =
  WsWWorkspaceIdProjectsRoute._addFileChildren(
    WsWWorkspaceIdProjectsRouteChildren,
  )

interface WsWWorkspaceIdSeatsBillingRouteChildren {
  WsWWorkspaceIdSeatsBillingBillingRoute: typeof WsWWorkspaceIdSeatsBillingBillingRoute
  WsWWorkspaceIdSeatsBillingPaymentRoute: typeof WsWWorkspaceIdSeatsBillingPaymentRoute
  WsWWorkspaceIdSeatsBillingPlanRoute: typeof WsWWorkspaceIdSeatsBillingPlanRoute
  WsWWorkspaceIdSeatsBillingSeatsRoute: typeof WsWWorkspaceIdSeatsBillingSeatsRoute
  WsWWorkspaceIdSeatsBillingIndexRoute: typeof WsWWorkspaceIdSeatsBillingIndexRoute
}

const WsWWorkspaceIdSeatsBillingRouteChildren: WsWWorkspaceIdSeatsBillingRouteChildren =
  {
    WsWWorkspaceIdSeatsBillingBillingRoute:
      WsWWorkspaceIdSeatsBillingBillingRoute,
    WsWWorkspaceIdSeatsBillingPaymentRoute:
      WsWWorkspaceIdSeatsBillingPaymentRoute,
    WsWWorkspaceIdSeatsBillingPlanRoute: WsWWorkspaceIdSeatsBillingPlanRoute,
    WsWWorkspaceIdSeatsBillingSeatsRoute: WsWWorkspaceIdSeatsBillingSeatsRoute,
    WsWWorkspaceIdSeatsBillingIndexRoute: WsWWorkspaceIdSeatsBillingIndexRoute,
  }

const WsWWorkspaceIdSeatsBillingRouteWithChildren =
  WsWWorkspaceIdSeatsBillingRoute._addFileChildren(
    WsWWorkspaceIdSeatsBillingRouteChildren,
  )

interface WsWWorkspaceIdRouteChildren {
  WsWWorkspaceIdBillingRoute: typeof WsWWorkspaceIdBillingRouteWithChildren
  WsWWorkspaceIdBrandsRoute: typeof WsWWorkspaceIdBrandsRouteWithChildren
  WsWWorkspaceIdConnectedAppsRoute: typeof WsWWorkspaceIdConnectedAppsRoute
  WsWWorkspaceIdCreditsRoute: typeof WsWWorkspaceIdCreditsRouteWithChildren
  WsWWorkspaceIdMembersRoute: typeof WsWWorkspaceIdMembersRouteWithChildren
  WsWWorkspaceIdNotificationsRoute: typeof WsWWorkspaceIdNotificationsRoute
  WsWWorkspaceIdOverviewRoute: typeof WsWWorkspaceIdOverviewRoute
  WsWWorkspaceIdProjectsRoute: typeof WsWWorkspaceIdProjectsRouteWithChildren
  WsWWorkspaceIdRequestsRoute: typeof WsWWorkspaceIdRequestsRoute
  WsWWorkspaceIdSeatsBillingRoute: typeof WsWWorkspaceIdSeatsBillingRouteWithChildren
  WsWWorkspaceIdSettingsRoute: typeof WsWWorkspaceIdSettingsRoute
  WsWWorkspaceIdIndexRoute: typeof WsWWorkspaceIdIndexRoute
}

const WsWWorkspaceIdRouteChildren: WsWWorkspaceIdRouteChildren = {
  WsWWorkspaceIdBillingRoute: WsWWorkspaceIdBillingRouteWithChildren,
  WsWWorkspaceIdBrandsRoute: WsWWorkspaceIdBrandsRouteWithChildren,
  WsWWorkspaceIdConnectedAppsRoute: WsWWorkspaceIdConnectedAppsRoute,
  WsWWorkspaceIdCreditsRoute: WsWWorkspaceIdCreditsRouteWithChildren,
  WsWWorkspaceIdMembersRoute: WsWWorkspaceIdMembersRouteWithChildren,
  WsWWorkspaceIdNotificationsRoute: WsWWorkspaceIdNotificationsRoute,
  WsWWorkspaceIdOverviewRoute: WsWWorkspaceIdOverviewRoute,
  WsWWorkspaceIdProjectsRoute: WsWWorkspaceIdProjectsRouteWithChildren,
  WsWWorkspaceIdRequestsRoute: WsWWorkspaceIdRequestsRoute,
  WsWWorkspaceIdSeatsBillingRoute: WsWWorkspaceIdSeatsBillingRouteWithChildren,
  WsWWorkspaceIdSettingsRoute: WsWWorkspaceIdSettingsRoute,
  WsWWorkspaceIdIndexRoute: WsWWorkspaceIdIndexRoute,
}

const WsWWorkspaceIdRouteWithChildren = WsWWorkspaceIdRoute._addFileChildren(
  WsWWorkspaceIdRouteChildren,
)

interface WsRouteChildren {
  WsCreateWorkspaceRoute: typeof WsCreateWorkspaceRoute
  WsInviteMembersRoute: typeof WsInviteMembersRoute
  WsNoAccessRoute: typeof WsNoAccessRoute
  WsWorkspacesRoute: typeof WsWorkspacesRouteWithChildren
  WsWWorkspaceIdRoute: typeof WsWWorkspaceIdRouteWithChildren
}

const WsRouteChildren: WsRouteChildren = {
  WsCreateWorkspaceRoute: WsCreateWorkspaceRoute,
  WsInviteMembersRoute: WsInviteMembersRoute,
  WsNoAccessRoute: WsNoAccessRoute,
  WsWorkspacesRoute: WsWorkspacesRouteWithChildren,
  WsWWorkspaceIdRoute: WsWWorkspaceIdRouteWithChildren,
}

const WsRouteWithChildren = WsRoute._addFileChildren(WsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  WsRoute: WsRouteWithChildren,
  DashboardMockRoute: DashboardMockRoute,
  DevSimRoute: DevSimRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  JoinTokenRoute: JoinTokenRoute,
  FeedbackFeedbackIdImageRoute: FeedbackFeedbackIdImageRoute,
  PublicArtifactsArtifactIdRoute: PublicArtifactsArtifactIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
